export default __webpack_public_path__ + "static/media/soraya-bg-green-yellow.818fc886.png";